import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import * as React from 'react';
import { a as EGDSIcon } from '../icon/index-chunk.esm.js';
import { c as classNames, b as EGDSContextWrapper } from '../index_orig/index-chunk.esm.js';
import styles from '../styles/uitk-egds-field.css';

const getClassNameList$2 = classNames.bind(styles);
class EGDSField extends React.Component {
    static displayName = 'EGDSField';
    static defaultProps = {
        hasBorder: true,
        hasFloatedLabel: true,
        hasVisibleLabel: true,
    };
    render() {
        const { className, labelClassName, label, instruction, invalid, hasFloatedLabel, icon, hasAutofill, hasBorder, hasVisibleLabel, children, required, } = this.props;
        const { id, disabled, placeholder, readOnly } = this.props;
        const cssClassNames = getClassNameList$2('uitk-field', className, {
            'has-autofill': hasAutofill,
            'has-floatedLabel-label': hasFloatedLabel,
            'has-icon': icon,
            'has-no-border': !hasBorder,
            'has-no-visible-label': !hasVisibleLabel,
            'has-placeholder': !!placeholder?.trim(),
            'has-textarea': React.Children.toArray(children).some((child) => !!(child?.type === 'textarea')),
            'is-disabled': disabled,
            'is-invalid': invalid,
            'is-readonly': readOnly,
            'is-required': required,
        });
        const labelClassNames = [];
        labelClassName && labelClassNames.push(labelClassName);
        if (!hasVisibleLabel || !placeholder) {
            labelClassNames.push('is-visually-hidden');
        }
        const labelAttrs = {
            className: labelClassNames.join(' '),
            id,
            label,
            placeholder,
        };
        const messageMarkup = (message, type) => {
            let output;
            const isString = (val) => typeof val === 'string';
            const isObject = (val) => typeof val === 'object';
            if (message) {
                if (isString(message)) {
                    output = jsx(EGDSFieldMessage, { id: id, message: message, type: type });
                }
                if (isObject(message)) {
                    output = (jsxs("div", { className: getClassNameList$2('uitk-field-messages'), children: [message.primary && (jsx(EGDSFieldMessage, { className: getClassNameList$2('uitk-field-message-primary'), id: id, message: message.primary, type: type })), message.secondary && (jsx(EGDSFieldMessage, { className: getClassNameList$2('uitk-field-message-secondary'), id: id, message: message.secondary, type: type }))] }));
                }
            }
            return output;
        };
        return (jsx(EGDSContextWrapper, { children: (context, data) => (jsxs(Fragment, { children: [jsxs("div", { className: cssClassNames, children: [jsx(EGDSFieldLabel, { ...labelAttrs }), children, !placeholder && hasVisibleLabel && (jsxs("div", { className: getClassNameList$2('uitk-field-label'), "aria-hidden": "true", children: [label, required && data?.hasRequiredFieldIndicator && (jsxs("span", { className: "uitk-field-required-asterisk", "aria-hidden": "true", children: [' ', "*"] }))] })), icon && jsx(EGDSIcon, { className: getClassNameList$2('uitk-field-icon'), name: icon })] }), invalid && messageMarkup(invalid, 'error'), instruction && messageMarkup(instruction, 'instruction')] })) }));
    }
}

const getClassNameList$1 = classNames.bind(styles);
class EGDSFieldLabel extends React.Component {
    static displayName = 'EGDSFieldLabel';
    render() {
        const { id, label, className } = this.props;
        const cssClasses = getClassNameList$1('uitk-field-label', className);
        return (jsx("label", { htmlFor: id, className: cssClasses, children: label }));
    }
}

const getClassNameList = classNames.bind(styles);
const EGDSFieldMessage = (props) => {
    const { className, message, id, type } = props;
    const cssClassNames = getClassNameList(`uitk-field-message`, `uitk-field-message-${type}`, `uitk-${type}-message`, className);
    return (jsx("div", { className: cssClassNames, id: `${id}-${type}`, children: message }));
};

export { EGDSField as E, EGDSFieldLabel as a, EGDSFieldMessage as b };
//# sourceMappingURL=index-chunk.esm.js.map
